import { Coordenada } from './taxa-entrega';
import { Endereco } from './endereco';

// Retorno de `aps://integracao/geo/coordenadas?cep&uf&municipio&logradouro&numero`, anonimo.
// Sondado em 2026-10-28:
//   - rua conhecida: `aproximadas: false`, ponto da porta
//   - rua que nao existe: 200 com `aproximadas: true` e o ponto no centro do CEP
//   - municipio invalido: 404; sem `cep` ou `uf`: 400
// O `endereco` devolvido tem o `cep` com PONTO ("60.325-645"), como o `integracao/cep`.
export type GeoCoordenadas = {
  validas: boolean;
  aproximadas: boolean;
  latitude: number;
  longitude: number;
  rota: string;
  endereco: any;
};

export type GeoCoordenadasConsulta = {
  cep: string;
  uf: string;
  municipio: string;
  logradouro: string;
  numero?: string;
};

// `cep` e `uf` sao exigidos pelo servidor, e sem municipio ele responde 404: sem os tres
// nao vale a chamada. O numero vai so com os digitos iniciais ("126A" -> "126").
export function geoConsultaMonta(cep: string, uf: string, municipio: string, logradouro: string, numero: string | number): GeoCoordenadasConsulta | null {
  const digitos = (cep || '').replace(/\D/g, '');
  if (digitos.length !== 8 || !(uf || '').trim() || !(municipio || '').trim()) {
    return null;
  }
  const consulta: GeoCoordenadasConsulta = {
    cep: digitos,
    uf: uf.trim(),
    municipio: municipio.trim(),
    logradouro: (logradouro || '').trim(),
  };
  const numeroDigitos = String(numero ?? '').trim().match(/^\d+/);
  if (numeroDigitos) {
    consulta.numero = numeroDigitos[0];
  }
  return consulta;
}

export function geoConsultaDeEndereco(endereco: Endereco): GeoCoordenadasConsulta | null {
  return geoConsultaMonta(endereco?.cep, endereco?.uf, endereco?.cidade, endereco?.logradouro, endereco?.numero);
}

export function geoConsultaParametros(consulta: GeoCoordenadasConsulta): string {
  return Object.keys(consulta)
    .filter(chave => consulta[chave])
    .map(chave => `${chave}=${encodeURIComponent(consulta[chave])}`)
    .join('&');
}

// Ponto aproximado (centro do CEP) ainda serve: e melhor que o mock, que inventa um ponto
// a ate 12 km da loja. Quem quiser distinguir le `aproximadas` no retorno.
export function geoCoordenada(retorno: GeoCoordenadas): Coordenada | null {
  if (!retorno?.validas || !Number.isFinite(retorno.latitude) || !Number.isFinite(retorno.longitude)) {
    return null;
  }
  return { latitude: retorno.latitude, longitude: retorno.longitude };
}
